import { Button } from "@src/appV2/redesign/components/Button";
import { useHistory } from "react-router-dom";

import { PLACEMENT_PATHS } from "../paths";

export function BrowseMoreJobsButton() {
  const history = useHistory();

  return (
    <Button
      fullWidth
      variant="contained"
      size="large"
      onClick={async () => {
        history.replace(PLACEMENT_PATHS.ROOT);
      }}
    >
      Browse more jobs
    </Button>
  );
}
